export default __webpack_public_path__ + "static/media/logo.bb1d0428.png";